(() => {
  if (window.ChicLocalizedContentLinks) return;
  const language = String(document.documentElement.lang || '').toLowerCase().split('-')[0];
  const scriptRoot = document.currentScript?.dataset.chicLocaleRoot;
  const root = String(window.Shopify?.routes?.root || scriptRoot || '/').replace(/\/+$/, '');
  const active = ['pt', 'es'].includes(language) && /^\/[a-z]{2}(?:-[a-z0-9]+)*$/i.test(root);
  const publicPath = /^\/(?:blogs|pages|collections|products|policies|search)(?:\/|$)/;
  const resolve = (value) => {
    if (!active || typeof value !== 'string' || !value || /^[#?]/.test(value)) return value;
    let url;
    try {
      url = new URL(value, window.location.href);
    } catch {
      return value;
    }
    if (!['http:', 'https:'].includes(url.protocol) || url.origin !== window.location.origin) return value;
    if (url.pathname !== '/' && !publicPath.test(url.pathname)) return value;
    url.pathname = url.pathname === '/' ? `${root}/` : `${root}${url.pathname}`;
    return value.startsWith('/') && !value.startsWith('//') ? `${url.pathname}${url.search}${url.hash}` : url.href;
  };
  const update = (anchor) => {
    if (anchor.hasAttribute('download')) return;
    const previous = anchor.getAttribute('href');
    const localized = resolve(previous);
    if (localized !== previous) anchor.setAttribute('href', localized);
  };
  const refresh = (scope = document) => {
    if (!active) return;
    if (scope.matches?.('a[href]')) update(scope);
    scope.querySelectorAll?.('a[href]').forEach(update);
  };
  window.ChicLocalizedContentLinks = Object.freeze({ resolve, refresh });
  if (!active) return;
  refresh();
  new MutationObserver((changes) => {
    for (const change of changes) {
      if (change.type === 'attributes') update(change.target);
      else for (const node of change.addedNodes) if (node.nodeType === 1) refresh(node);
    }
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['href'] });
})();
